import CardLayout from './dashboard/CardLayout.vue';
import PrimaryLayout from './dashboard/PrimaryLayout.vue';
import SecondaryLayout from './dashboard/SecondaryLayout.vue';

export default function registerLayouts(app) {
    app.component('PrimaryLayout', PrimaryLayout);
    app.component('SecondaryLayout', SecondaryLayout);
    app.component('CardLayout', CardLayout);
}
